import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {EmailConfirmationComponent} from './email-confirmation.component';
import {EmailConfirmationRoutingModule} from './email-confirmation-routing.module';
import {EmailConfirmationService} from './services/email-confirmation.service';
import {EmailConfirmationRepository} from './repositories/email-confirmation.repository';

@NgModule({
  declarations: [
    EmailConfirmationComponent,
  ],
  imports: [
    CommonModule,
    EmailConfirmationRoutingModule
  ],
  providers: [
    EmailConfirmationService,
    {
      provide: 'IEmailConfirmationRepository',
      useClass: EmailConfirmationRepository,
    },
  ],
  exports: [
    EmailConfirmationComponent,
  ],
})
export class EmailConfirmationModule {}
